<template>
<div :class="groupclass">
<d-label v-if="label" :label="label" />
<div class="input-group">
  <input :class="getclass" 
      type="text" 
      :placeholder="placeholder"
      ref="input"  v-bind:value="vvalue"
      @blur="updateValue($event.target.value)"
      @keyup.enter="updateValue($event.target.value)"
      :readonly="readonly"
      >
  <div v-if="conv" class="input-group-append" :class="convclass">
    <span class="input-group-text">{{conv}}</span>
  </div>
</div>
 </div> 
</template>

<script>
import mixins from "@/mixin"
export default {
  mixins:[mixins],
  props: {
    label:String,
    small:Boolean,
    large:Boolean,
    noborder:Boolean,
    cols:Number,
    placeholder:String,
    value:{},
    conv:String,
    size:String,
    readonly:Boolean
  },
  data() {
    return {
        valid:true,
    }
  },
  methods: {
    updateValue: function (v) {
      var q=Number.parseFloat(v.replace(',','.'));
      this.valid=!Number.isNaN(q);
      this.vvalue=v;
      this.modeinput=false;
      if (this.valid) 
        this.$emit('input',this.fromvalue(q))
      else if (v=="") {
      }
    },
    tovalue(v) {
      if (!this.conv) return v;
      switch(this.conv.toLowerCase()) {
      case "%":
          return v*100;
      case "m":
          return v/100;
      case "cm":
          return v/10;
      default: 
        return v;
      }
    },
    fromvalue(v)  {
      if (!this.conv) return v;
      switch(this.conv.toLowerCase()) {
      case "%":
          return v/100;
      case "m":
           return v*100;
      case "cm":
          return v*10;
      default:
        return v;
      }
    }
  },
  computed: {
    getclass() {
      var aa="form-control col";
      if (this.noborder) aa+=" noborder"
      if (this.small) aa+=" small"
      if (this.large) aa+=" large"
      if (!this.valid) aa+=" is-invalid";
      if (this.conv) aa+=" connectright"
      return aa;
    },
    convclass() {
      if (this.small) return "small";
      if (this.large) return "large";
      return "";
    },
    groupclass() {
      if(!this.cols) { return false;}
        if (this.cols && Number.isInteger(this.cols) && this.cols>0 && this.cols<13)
        return "px-2 col-"+this.cols;
      else 
         return "px-2 col"
    },
    vvalue:{
      get() {return this.tovalue(this.value);},
      set(v) {}
    }
  }
}
</script>

<style scoped>
  /* .ff {
    text-align: right;
  } */

</style>




// WEBPACK FOOTER //
// src/_eng/globals/dnumber.vue